import { createFrontend, createBackend } from "cad-analyzer-library";
import openCascadeWorker from "comlink-loader!cad-analyzer-library/build/cad-analyzer-worker";
import moment from "moment";
export const load3DViewer = async (file, extension) => {
    try {
        let viewport;
        let ele = document.createElement("div");
        ele.setAttribute("id", "cad-analyzer");
        // document.body.appendChild(ele);

        viewport = await createFrontend(
            openCascadeWorker,
            document.getElementById("cad-analyzer")
        );

        viewport = await createBackend(
            openCascadeWorker,
            document.getElementById("cad-analyzer")
        );

        const onProgress = (progress) => {
            console.log("loading progress: ", progress);
        };

        let type = extension.toUpperCase();
        let resource = file;

        if (type === "STP") type = "STEP";
        const loadFileResult = await viewport.addFileFromURL(
            type,
            resource,
            undefined,
            onProgress
        );

        await viewport.setActiveFileIndex(loadFileResult.index);
    } catch (err) {
        console.log(
            "load error in trigger on" +
            moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
            err
        );
    }
};